import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import ReactAudioPlayer from "react-audio-player";
import autoBind from "react-autobind";
import shadowRoot from "react-shadow";

import TimelineActivity from "~/components/drawers/timeline/activity";
import Select from "~/components/forms/dropdowns/SelectWrapper/Select";
import ActivityEditor from "~/components/forms/HtmlEditors/ActivityEditor";
import { CALL_DISPOSITIONS } from "~/constants/dropdowns/CallDispositions";
import LeadHelpers from "~/helpers/lead_helpers";

const callDisposition = {
  no_answer: "No Answer",
  closed: "Completed",
  voicemail: "Voicemail",
  busy: "Busy",
  wrong_number: "Wrong Number",
  canceled: "Canceled",
  failed: "Failed",
};

class TimelineActivityPhoneCall extends TimelineActivity {
  constructor(props) {
    super(props);

    autoBind(this);
  }

  renderForm() {
    const { activity } = this.state;
    const call_disposition = activity.parameters?.call_disposition;

    return (
      <form onSubmit={this.onSubmit}>
        <ActivityEditor
          value={activity.body}
          onChange={(html) => {
            this.setState((prevState) => ({
              activity: { ...prevState.activity, body: html },
              queuedChanges: { ...prevState.queuedChanges, body: html },
            }));
          }}
          placeholder="Enter Text"
          activityType="phone_call"
          leadId={this.state.lead?.id}
        />

        <div className="col-lg-4 p0 mt5">
          <Select
            id="call_disposition"
            name="call_disposition"
            placeholder="Call Disposition"
            value={call_disposition || ""}
            onChange={(opt) => {
              const newCallDisposition = opt?.value || "";
              this.setState((prevState) => ({
                activity: {
                  ...prevState.activity,
                  parameters: {
                    ...prevState.activity.parameters,
                    call_disposition: newCallDisposition,
                  },
                },
                queuedChanges: {
                  ...prevState.queuedChanges,
                  // onSubmit sends queuedChanges.parameters as the FULL parameters
                  // blob (replacing it server-side). Seed from the existing
                  // activity.parameters so voicemail-drop metadata (voicemail_drop,
                  // voicemail_recording_name, voicemail_recording_duration_seconds)
                  // survives a disposition edit — otherwise the "Voicemail drop:"
                  // line vanishes on the next fetch.
                  parameters: {
                    ...prevState.activity.parameters,
                    ...prevState.queuedChanges.parameters,
                    call_disposition: newCallDisposition,
                  },
                },
              }));
            }}
            options={CALL_DISPOSITIONS}
            isSearchable
          />
        </div>

        <div className="mt5">
          <button
            type="submit"
            className="btn btn-primary btn-sm mr5"
            disabled={this.state.sending}
          >
            {this.state.sending ? (
              <span>
                <FontAwesomeIcon icon="far fa-spinner" pulse className="mr5" />{" "}
                Saving
              </span>
            ) : (
              "Save"
            )}
          </button>
          <a
            href="#"
            onClick={() => {
              this.setState({ queuedChanges: {}, editing: false });
            }}
            className="btn btn-secondary btn-sm"
          >
            Cancel
          </a>
        </div>
        {this.renderUnsupportedVariablesWarning()}
      </form>
    );
  }

  renderView() {
    const { activity } = this.state;
    const { parameters, voice_call } = activity;

    if (!activity) {
      return null;
    }

    return (
      <div>
        {voice_call && (
          <span>
            {_lodash.capitalize(voice_call.direction)} call to the{" "}
            {LeadHelpers.renderPhoneNumber(voice_call.to)}{" "}
            {LeadHelpers.renderDuration(voice_call.duration)}
          </span>
        )}

        {parameters && parameters.call_disposition && (
          <div className="mt-2">
            Call Disposition: {callDisposition[parameters.call_disposition]}
          </div>
        )}

        {voice_call && voice_call.record_url && (
          <div className="mt-2">
            <ReactAudioPlayer src={voice_call.record_url} controls />
          </div>
        )}

        {parameters?.voicemail_drop === true && (
          <div className="mt-2 text-green">
            Voicemail drop: {parameters.voicemail_recording_name}
          </div>
        )}

        {activity.body && (
          <shadowRoot.div className="mt-2 form-control font-activity">
            <div
              className="content"
              dangerouslySetInnerHTML={{ __html: activity.body || "" }}
            />
          </shadowRoot.div>
        )}
      </div>
    );
  }
}

TimelineActivityPhoneCall.defaultProps = {
  editable: true,
  deletable: true,
  title: "Phone Call",
  icon: "phone-alt",
  prefix: "fas",
  color: "text-pink",
  alwaysPublic: false,
};

export default TimelineActivityPhoneCall;
